import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export type Weekday =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export const weeklyDinnerItemSchema = surrealRecordSchema.extend({
  weekday: z.number(),
  value: z.string(),
  updatedAt: z.coerce.date(),
});
export const weeklyDinnerItemsSchema = z.array(weeklyDinnerItemSchema);
export const weeklyDinnerItemUpdateSchema = weeklyDinnerItemSchema.omit({
  id: true,
  weekday: true,
  updatedAt: true,
});

export type WeeklyDinnerItem = z.infer<typeof weeklyDinnerItemSchema>;
export type WeeklyDinnerItemUpdate = z.infer<
  typeof weeklyDinnerItemUpdateSchema
>;
